import {Button, Form, Input, message, Radio, Space} from "antd"
import {useNavigate} from "react-router-dom"
import {ArrowLeft, Send} from "lucide-react"
import React, {useState, useEffect} from "react"
import {images} from "../../../constants";
import Localization from "../../../components/Localizations/Localization";
import {useTranslation} from "react-i18next";
import {playFeedbackWave} from "../../../utils/feedbackWave";

const DeviceRegistrationSecondForm = () => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const [form] = Form.useForm()
    const [maintenanceOption, setMaintenanceOption] = useState("scheduled")

    useEffect(() => {

        // Retrieve data from step 1
        const step1Data = JSON.parse(localStorage.getItem("deviceRegistrationStep1") || "{}")

        // Retrieve data from step 2
        const step2Data = form.getFieldsValue()

        // Merge both step data
        const completeFormData = {
            ...step1Data,
            ...step2Data,
        }

        console.log(completeFormData)
    })

    const handleSubmit = async () => {
        try {
            await form.validateFields()

            // Retrieve data from step 1
            const step1Data = JSON.parse(localStorage.getItem("deviceRegistrationStep1") || "{}")

            // Retrieve data from step 2
            const step2Data = form.getFieldsValue()

            // Merge both step data
            const completeFormData = {
                ...step1Data,
                ...step2Data,
            }

            console.log("Sending complete form data to backend:", completeFormData)

            // Send the merged data to backend
            const response = await fetch("https://your-backend-api.com/device/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(completeFormData),
            })

            if (response.ok) {
                playFeedbackWave('success');
                message.success("Device registered successfully")

                // Clear localStorage after successful submission
                localStorage.removeItem("deviceRegistrationStep1")
                localStorage.removeItem("deviceRegistrationStep2")

                navigate("/device/registration")
            } else {
                playFeedbackWave('failure');
                message.error("Failed to register device")
            }
        } catch (error) {
            console.error("Error submitting form:", error)
        }
    }

    const handleBack = () => {
        // Save current form data before going back
        const currentData = form.getFieldsValue()
        localStorage.setItem("deviceRegistrationStep2", JSON.stringify(currentData))

        navigate("/device/registration")
    }

    return (
        <div className="device-registration-container">
            <div className="banner">
                <div className="banner-logo">
                    <img src={images.deviceRegistrationBanner} alt="fiscalBOX"/>
                </div>
                <div className="banner-text">
                    <h1>{t("pages.devices.registrationForm.title")}</h1>
                    <p>{t("pages.devices.registrationForm.description")}</p>
                </div>
            </div>

            <div className="navigation-bar">
                <div>
                    <Localization/>
                </div>
                <div className="step-indicator">
                    <span className="step" onClick={handleBack}>{t("pages.devices.registrationForm.steps.step1")}</span>
                    <span className="step-divider"></span>
                    <span className="step active">{t("pages.devices.registrationForm.steps.step2")}</span>
                </div>
            </div>

            <div className="form-title">
                <h2>{t("pages.devices.registrationForm.form2.title")}</h2>
                <p>{t("pages.devices.registrationForm.form2.description")}</p>
            </div>

            <Form form={form} layout="vertical" className="registration-form">
                <Form.Item label={t("pages.devices.registrationForm.form2.field1.label")} name="fullNameS2"
                           rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}>
                    <Input placeholder={t("pages.devices.registrationForm.form2.field1.placeholder")}/>
                </Form.Item>

                <Form.Item
                    label={t("pages.devices.registrationForm.form2.field2.label")}
                    name="phoneNumberS2"
                    rules={[{required: true, message: t("pages.devices.registrationForm.common.error.error1")}]}
                >
                    <Input placeholder={t("pages.devices.registrationForm.form2.field2.placeholder")}/>
                </Form.Item>

                <Form.Item
                    label={t("pages.devices.registrationForm.form2.field3.label")}
                    name="privactTermS2">
                    <Radio.Group
                        value={maintenanceOption}
                        onChange={(e) => setMaintenanceOption(e.target.value)}
                        className="maintenance-radio-group"
                    >
                        <Space direction="vertical">
                            <Radio value="agree" className="radio-option">
                                {t("pages.devices.registrationForm.form2.field3.option1.label")}
                            </Radio>
                        </Space>
                    </Radio.Group>
                </Form.Item>

                <div className="button-container">
                    <Button icon={<ArrowLeft size={16}/>} onClick={handleBack} className="back-step-button">
                        {t("pages.devices.registrationForm.buttons.button2")}
                    </Button>
                    <Button icon={<Send size={16}/>} type="primary" onClick={handleSubmit} className="submit-button">
                        {t("pages.devices.registrationForm.buttons.button1")}
                    </Button>
                </div>
            </Form>
        </div>
    )
}

export default DeviceRegistrationSecondForm

